import { Book, Bot, HelpCircle, MessageCircle } from 'lucide-react';
import React from 'react';
import Navigation from './ZeronineHeader';
import Footer from './ZeronineFooter';

const HelpSupport = () => (
   <>
      <Navigation />
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-purple-50 pt-32 pb-20 px-4">
         <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
               <div className="inline-block px-4 py-2 bg-purple-100 rounded-full mb-6">
                  <span className="text-purple-600 font-bold">❓ HELP & SUPPORT</span>
               </div>
               <h1 className="text-5xl md:text-6xl font-black text-gray-900 mb-6">Help Center</h1>
               <p className="text-xl text-gray-600">Get help with ZeroNine features and GST filing</p>
            </div>

            <div className="mb-12">
               <div className="bg-white rounded-3xl p-8 border-2 border-gray-200 hover:border-purple-300 hover:shadow-2xl transition-all text-center">
                  <MessageCircle className="w-16 h-16 text-purple-600 mx-auto mb-4" />
                  <h3 className="text-2xl font-black text-gray-900 mb-4">Support</h3>
                  <p className="text-gray-600 mb-6">Need help? Our support team is here to assist you</p>
                  <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
                     <div className="flex items-center gap-2">
                        <span className="font-semibold text-gray-900">Email:</span>
                        <a href="mailto:help@zeronine.ai" className="text-purple-600 hover:text-purple-700 font-medium">
                           help@zeronine.ai
                        </a>
                     </div>
                     <span className="hidden sm:inline text-gray-300">|</span>
                     <div className="flex items-center gap-2">
                        <span className="font-semibold text-gray-900">Phone:</span>
                        <a href="tel:+917283990909" className="text-purple-600 hover:text-purple-700 font-medium">
                           +91 72839-90909
                        </a>
                     </div>
                  </div>
               </div>
            </div>

            <div className="bg-white rounded-3xl shadow-2xl p-8 border-2 border-gray-200">
               <h2 className="text-3xl font-black text-gray-900 mb-8 text-center">Frequently Asked Questions</h2>
               <div className="space-y-6">
                  {[
                     {
                        q: 'How do I set up GST filing?',
                        a: 'Go to Settings → GST Setup → Enter your GSTIN → Verify details → Start filing returns',
                     },
                     {
                        q: 'Can I migrate from Tally?',
                        a: 'Yes! Use our AI-powered migration tool to transfer all your data automatically',
                     },
                     {
                        q: 'How secure is my financial data?',
                        a: 'We use bank-level 256-bit encryption and are ISO 27001 certified with blockchain audit trails',
                     },
                     {
                        q: 'Do you offer training?',
                        a: 'Yes! We provide free video tutorials, live training sessions, and dedicated onboarding',
                     },
                  ].map((faq, idx) => (
                     <div key={idx} className="p-6 bg-gray-50 rounded-2xl border border-gray-200">
                        <h3 className="text-xl font-bold text-gray-900 mb-3 flex items-center gap-3">
                           <HelpCircle className="w-6 h-6 text-blue-600" />
                           {faq.q}
                        </h3>
                        <p className="text-gray-700 ml-9">{faq.a}</p>
                     </div>
                  ))}
               </div>
            </div>
         </div>
      </div>
      <Footer />
   </>
);

export default HelpSupport;
